var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 530,
    viewBox: "0 0 626 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.998 341.305L404.956 443.629C414.955 449.41 431.181 449.421 441.18 443.629L618.137 341.316C628.136 335.535 628.136 326.164 618.137 320.383L441.341 218.272C431.331 212.492 415.104 212.492 405.094 218.272L228.02 320.394C218 326.153 218 335.524 227.998 341.305Z",
    fill: "url(#paint0_linear_504_7204)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87147 408.004L100.876 463.568C106.303 466.71 115.105 466.71 120.532 463.568L216.547 408.004C221.974 404.862 221.974 399.776 216.547 396.645L120.628 341.241C115.191 338.11 106.388 338.11 100.961 341.241L4.88215 396.645C-0.555289 399.787 -0.555289 404.873 4.87147 408.004Z",
    fill: "url(#paint1_linear_504_7204)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.491 475.996L255.186 510.51C259.022 512.459 263.559 512.459 267.396 510.51L327.09 475.985C330.466 474.04 330.466 470.877 327.09 468.922L267.449 434.483C263.609 432.533 259.069 432.533 255.228 434.483L195.491 468.933C192.084 470.888 192.084 474.04 195.491 475.996Z",
    fill: "url(#paint2_linear_504_7204)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.393 501.149L396.816 500.807L159.171 363.82V336.721C159.171 336.078 159.692 335.556 160.335 335.556C160.978 335.556 161.5 336.078 161.5 336.721V362.473L397.393 498.414L533.243 419.94L370.686 326.068C370.129 325.746 369.937 325.033 370.259 324.476C370.58 323.918 371.293 323.727 371.851 324.048L537.858 419.918L397.393 501.149Z",
    fill: "url(#paint3_linear_504_7204)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.388 429.332L181.284 414.832L130.841 443.672L156.191 458.311L206.388 429.332Z",
    fill: "url(#paint4_linear_504_7204)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.117 438.992L249.525 454.24L164.555 501.79L139.451 487.301L223.117 438.992Z",
    fill: "url(#paint5_linear_504_7204)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.555 405.172L130.841 424.353L105.993 410.002L139.462 390.672L164.555 405.172Z",
    fill: "url(#paint6_linear_504_7204)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M506.505 402.747L499.743 412.086L499.422 412.524L495.299 418.187L478.944 415.163C476.013 417.2 472.894 418.949 469.628 420.388L476.038 427.868L476.775 428.723L472.758 429.727L448.188 435.818L440.967 427.451C436.549 427.845 432.111 427.969 427.678 427.825L421.268 436.609L394.391 431.629L393.323 431.426L392.105 431.202L392.297 430.935L398.472 422.386C395.132 421.143 391.913 419.594 388.857 417.76L372.641 421.788L367.674 416.039L359.929 407.042L366.467 405.418L376.017 403.046C375.353 400.763 375.207 398.361 375.59 396.015L365.975 394.23L359.267 392.98L370.483 377.54L386.646 380.542C387.266 380.083 387.907 379.655 388.558 379.228L389.231 378.79C390.086 378.266 390.962 377.721 391.881 377.24C393.195 376.524 394.573 375.83 396.015 375.178L395.171 374.206L388.996 367.046L417.562 359.951L424.505 368.019C426.257 367.858 428.02 367.73 429.793 367.645C432.207 367.527 434.632 367.506 437.089 367.559H438.328L440.048 365.187L440.166 365.005L440.753 364.204L444.439 359.128L450.304 360.197L473.613 364.471L467.503 372.902C469.453 373.625 471.364 374.449 473.228 375.37C474.745 376.083 476.17 376.87 477.502 377.732L493.13 373.853L505.842 388.599L497.692 390.619L490.086 392.51C490.72 394.837 490.819 397.277 490.374 399.648L498.92 401.24L506.505 402.747Z",
    fill: "url(#paint7_linear_504_7204)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M507.145 385.18L500.373 394.508L500.052 394.957L495.929 400.62L479.574 397.586C476.648 399.63 473.528 401.38 470.258 402.811L476.668 410.291L477.405 411.145L473.388 412.15L448.818 418.251L441.597 409.885C437.179 410.279 432.741 410.401 428.308 410.248L421.898 419.042L395.021 414.063L393.953 413.86L392.735 413.624L392.927 413.368L399.102 404.82C395.759 403.577 392.54 402.025 389.487 400.182L373.271 404.211L368.304 398.462L360.559 389.465L367.097 387.851L376.647 385.468C375.982 383.189 375.836 380.791 376.22 378.448L366.605 376.653L359.907 375.413L371.113 359.973L387.276 362.965C387.896 362.516 388.537 362.078 389.188 361.661C389.413 361.501 389.637 361.362 389.861 361.223C390.716 360.689 391.592 360.154 392.51 359.673C393.824 358.947 395.203 358.263 396.645 357.611L395.801 356.628L389.626 349.469L418.191 342.374L425.135 350.441C426.887 350.281 428.65 350.163 430.476 350.078C432.891 349.96 435.316 349.928 437.773 349.992H439.012L440.732 347.62L440.849 347.449L441.437 346.637L445.122 341.562L450.987 342.63L474.296 346.904L468.186 355.335C470.216 356.104 472.124 356.931 473.912 357.814C475.378 358.523 476.805 359.311 478.185 360.176L493.814 356.286L506.526 371.043L498.386 373.062L490.769 374.954C491.404 377.28 491.503 379.721 491.057 382.092L499.604 383.673L507.145 385.18Z",
    fill: "url(#paint8_linear_504_7204)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M433.731 392.413C446.484 392.137 456.705 386.503 456.56 379.83C456.416 373.157 445.961 367.972 433.208 368.248C420.456 368.524 410.235 374.157 410.38 380.83C410.524 387.503 420.979 392.689 433.731 392.413Z",
    fill: "url(#paint9_linear_504_7204)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.679 410.259L479.178 408.602C478.377 409.169 477.512 409.724 476.679 410.259Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M396.613 357.611C395.181 358.263 393.803 358.947 392.489 359.673C391.571 360.176 390.695 360.742 389.84 361.223L389.167 361.661L389.605 349.479L396.613 357.611Z",
    fill: "url(#paint10_linear_504_7204)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.232 346.99L473.837 357.9C472.05 357.009 470.141 356.183 468.111 355.421L474.232 346.99Z",
    fill: "url(#paint11_linear_504_7204)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M506.44 371.118L506.045 382.134L499.507 383.759L490.961 382.177C491.417 379.807 491.318 377.364 490.673 375.039L498.29 373.148L506.44 371.118Z",
    fill: "url(#paint12_linear_504_7204)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M507.134 385.18L506.739 396.196L495.533 411.637L495.928 400.62L500.041 394.957L507.134 385.18Z",
    fill: "url(#paint13_linear_504_7204)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M495.929 400.62L495.534 411.637L479.179 408.602L479.574 397.585L495.929 400.62Z",
    fill: "url(#paint14_linear_504_7204)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M479.574 397.585L479.179 408.602L476.679 410.258L470.27 402.779C473.534 401.358 476.651 399.618 479.574 397.585Z",
    fill: "url(#paint15_linear_504_7204)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M477.416 411.124L477.02 422.13L448.466 429.236L448.861 418.219L473.41 412.118L477.416 411.124Z",
    fill: "url(#paint16_linear_504_7204)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M448.862 418.219L448.467 429.236L441.245 420.859L441.64 409.842L448.862 418.219Z",
    fill: "url(#paint17_linear_504_7204)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M441.64 409.842L441.245 420.858C436.827 421.257 432.389 421.382 427.956 421.232L428.351 410.216C432.785 410.365 437.223 410.24 441.64 409.842Z",
    fill: "url(#paint18_linear_504_7204)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M428.351 410.216L427.956 421.233L421.589 430.016L421.984 419.01L428.351 410.216Z",
    fill: "url(#paint19_linear_504_7204)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M399.166 404.82L392.991 413.368C391.624 412.695 390.331 411.979 389.113 411.231L389.509 400.214C392.575 402.05 395.809 403.592 399.166 404.82Z",
    fill: "url(#paint20_linear_504_7204)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M421.984 419.01L421.589 430.016L392.394 424.609L392.799 413.603L394.007 413.827L395.107 414.03L421.984 419.01Z",
    fill: "url(#paint21_linear_504_7204)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M389.509 400.182L389.114 411.199L372.897 415.238L373.293 404.221L389.509 400.182Z",
    fill: "url(#paint22_linear_504_7204)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M373.293 404.221L372.898 415.238L360.186 400.481L360.581 389.465L368.336 398.462L373.293 404.221Z",
    fill: "url(#paint23_linear_504_7204)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M376.669 385.468L367.119 387.84L359.491 386.43L359.886 375.413L366.584 376.653L376.199 378.448C375.829 380.794 375.99 383.193 376.669 385.468Z",
    fill: "url(#paint24_linear_504_7204)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M507.146 385.18L500.373 394.508C467.033 364.514 427.732 356.714 395.78 356.628L389.605 349.469L418.171 342.374L425.114 350.441C426.866 350.281 428.629 350.163 430.456 350.078C432.87 349.96 435.295 349.928 437.752 349.992H438.991L440.711 347.62L440.829 347.449L441.416 346.637L445.102 341.562L450.966 342.63L474.276 346.904L468.165 355.335C470.195 356.104 472.104 356.931 473.891 357.814C475.357 358.523 476.784 359.311 478.164 360.176L493.793 356.286L506.505 371.043L498.365 373.062L490.748 374.954C491.383 377.28 491.482 379.721 491.037 382.092L499.583 383.673L507.146 385.18Z",
    fill: "url(#paint25_linear_504_7204)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8906 277.972C42.8906 277.972 44.3328 340.236 45.0271 398.718C45.0271 398.718 46.512 304.494 47.1637 277.972H42.8906Z",
    fill: "url(#paint26_linear_504_7204)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4454 275.238C62.676 268.385 61.3622 258.588 54.511 253.356C47.6597 248.124 37.8655 249.438 32.6349 256.291C27.4043 263.144 28.7181 272.941 35.5693 278.173C42.4206 283.405 52.2148 282.091 57.4454 275.238Z",
    fill: "url(#paint27_linear_504_7204)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M614.431 254.315C614.431 254.315 615.253 312.722 615.627 367.581C615.627 367.581 616.471 279.191 616.824 254.315H614.431Z",
    fill: "url(#paint28_linear_504_7204)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M624.509 248.752C625.274 243.92 621.978 239.383 617.148 238.617C612.317 237.852 607.78 241.149 607.015 245.981C606.25 250.813 609.546 255.35 614.377 256.116C619.208 256.881 623.744 253.584 624.509 248.752Z",
    fill: "url(#paint29_linear_504_7204)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M394.188 135.065C394.188 135.065 395.63 197.97 396.324 257.061C396.324 257.061 397.809 161.875 398.461 135.065H394.188Z",
    fill: "url(#paint30_linear_504_7204)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M409.023 131.767C413.997 124.725 412.321 114.984 405.281 110.009C398.241 105.034 388.502 106.709 383.529 113.751C378.555 120.793 380.231 130.535 387.271 135.51C394.311 140.485 404.05 138.809 409.023 131.767Z",
    fill: "url(#paint31_linear_504_7204)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M254.973 415.323C254.973 415.323 255.699 474.393 256.041 529.883C256.041 529.883 256.778 440.498 257.109 415.323H254.973Z",
    fill: "url(#paint32_linear_504_7204)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M263.86 409.147C263.86 412.308 261.957 415.156 259.037 416.365C256.118 417.573 252.758 416.903 250.526 414.667C248.293 412.431 247.628 409.069 248.84 406.151C250.052 403.232 252.903 401.332 256.062 401.336C258.132 401.336 260.117 402.159 261.58 403.625C263.043 405.09 263.863 407.077 263.86 409.147Z",
    fill: "url(#paint33_linear_504_7204)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.539 162.27L114.625 363.146L323.33 242.614L323.288 41.7268L114.539 162.27Z",
    fill: "#F3F6FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.539 182.273L323.288 61.73V41.7268L114.539 162.27V182.273Z",
    fill: "url(#paint34_linear_504_7204)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M285.429 93.9254V214.479L355.026 174.28L354.951 53.78L285.429 93.9254Z",
    fill: "#D4DFFC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M308.727 131.635C308.419 131.637 308.134 131.474 307.98 131.207C307.863 131.009 307.83 130.772 307.888 130.55C307.947 130.327 308.091 130.137 308.289 130.021L337.218 113.32C337.487 113.129 337.84 113.108 338.129 113.265C338.419 113.422 338.594 113.729 338.582 114.058C338.57 114.387 338.373 114.681 338.072 114.816L309.155 131.517C309.026 131.595 308.878 131.636 308.727 131.635Z",
    fill: "#B4CBFC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M301.538 144.158C301.229 144.154 300.944 143.988 300.79 143.72C300.556 143.306 300.699 142.782 301.11 142.544L344.482 117.487C344.895 117.253 345.419 117.396 345.657 117.808C345.773 118.006 345.806 118.242 345.748 118.465C345.69 118.687 345.546 118.878 345.347 118.994L301.976 144.04C301.842 144.115 301.691 144.156 301.538 144.158Z",
    fill: "#B4CBFC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M301.548 152.567C301.236 152.565 300.948 152.399 300.79 152.129C300.555 151.713 300.698 151.185 301.11 150.943L344.588 125.832C344.997 125.648 345.479 125.803 345.705 126.191C345.93 126.579 345.826 127.074 345.464 127.339L301.975 152.45C301.845 152.523 301.698 152.564 301.548 152.567Z",
    fill: "#B4CBFC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M301.549 160.934C301.157 160.935 300.814 160.673 300.711 160.295C300.608 159.917 300.772 159.518 301.111 159.321L344.599 134.199C345.015 133.96 345.546 134.104 345.785 134.52C346.024 134.936 345.881 135.467 345.465 135.706L301.976 160.817C301.847 160.895 301.699 160.935 301.549 160.934Z",
    fill: "#B4CBFC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M308.791 165.112C308.399 165.113 308.056 164.851 307.953 164.473C307.851 164.095 308.014 163.696 308.353 163.499L337.356 146.754C337.766 146.547 338.266 146.696 338.496 147.093C338.725 147.491 338.605 147.999 338.221 148.25L309.218 165.005C309.087 165.075 308.94 165.112 308.791 165.112Z",
    fill: "#B4CBFC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7461 232.901V353.444L149.343 313.245L149.268 192.745L79.7461 232.901Z",
    fill: "url(#paint35_linear_504_7204)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M103.108 270.61C102.717 270.611 102.373 270.349 102.271 269.971C102.168 269.593 102.332 269.193 102.67 268.996L131.673 252.242C132.089 252.003 132.62 252.146 132.859 252.562C133.098 252.978 132.955 253.509 132.539 253.748L103.536 270.492C103.408 270.573 103.259 270.614 103.108 270.61Z",
    fill: "url(#paint36_linear_504_7204)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8655 283.165C95.5532 283.163 95.2651 282.997 95.107 282.727C94.8724 282.311 95.015 281.783 95.4275 281.541L138.874 256.452C139.142 256.276 139.485 256.262 139.766 256.417C140.047 256.572 140.219 256.87 140.214 257.191C140.208 257.512 140.025 257.803 139.739 257.948L96.2501 283.069C96.1304 283.129 95.9992 283.162 95.8655 283.165Z",
    fill: "url(#paint37_linear_504_7204)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8655 291.532C95.5532 291.53 95.2651 291.363 95.107 291.094C94.8724 290.677 95.015 290.149 95.4275 289.908L138.906 264.797C139.315 264.613 139.797 264.768 140.022 265.156C140.248 265.543 140.144 266.039 139.782 266.304L96.2928 291.414C96.1621 291.488 96.0154 291.528 95.8655 291.532Z",
    fill: "url(#paint38_linear_504_7204)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.866 299.899C95.4745 299.9 95.131 299.638 95.0284 299.26C94.9258 298.882 95.0897 298.482 95.4281 298.285L138.917 273.164C139.186 273.009 139.517 273.01 139.785 273.166C140.054 273.321 140.219 273.609 140.218 273.919C140.217 274.229 140.051 274.516 139.782 274.67L96.2933 299.781C96.1646 299.859 96.0166 299.9 95.866 299.899Z",
    fill: "url(#paint39_linear_504_7204)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.109 304.088C102.796 304.085 102.508 303.919 102.35 303.65C102.116 303.233 102.258 302.705 102.671 302.463L131.674 285.719C132.09 285.48 132.621 285.624 132.86 286.04C133.099 286.456 132.955 286.987 132.539 287.226L103.536 303.97C103.406 304.046 103.259 304.087 103.109 304.088Z",
    fill: "url(#paint40_linear_504_7204)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M210.063 268.89V275.889C210.062 276.836 210.566 277.711 211.386 278.185C212.206 278.659 213.216 278.66 214.036 278.186L258.551 252.477C260.261 251.484 261.315 249.657 261.318 247.679V240.723C261.322 239.764 260.812 238.877 259.982 238.397C259.152 237.918 258.129 237.921 257.301 238.404L212.851 264.049C211.122 265.047 210.059 266.893 210.063 268.89Z",
    fill: "url(#paint41_linear_504_7204)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M556.467 269.178C553.048 308.928 543.434 347.118 543.071 348.561L524.975 338.014L523.682 322.798L518.223 334.082L476.305 309.655L476.785 294.214L468.538 305.135L450.068 294.364L451.863 280.772L443.701 290.688L406.451 268.975C406.451 268.975 421.791 245.862 430.53 225.368C433.722 217.604 436.37 209.628 438.456 201.496L556.467 269.178Z",
    fill: "url(#paint42_linear_504_7204)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M593.162 319.635C585.667 322.696 578.377 326.237 571.338 330.235L568.282 318.93L567.214 332.661C554.395 340.311 543.093 348.603 543.093 348.603C543.456 347.161 553.07 308.971 556.489 269.221L567.535 262.81L582.49 254.112C586.069 282.001 593.162 319.635 593.162 319.635Z",
    fill: "url(#paint43_linear_504_7204)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M580.717 226.201L557.664 241.855L444.14 175.723L468.71 161.511L580.717 226.201Z",
    fill: "url(#paint44_linear_504_7204)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M557.632 241.855C557.685 250.756 557.226 260.021 556.425 269.178L438.403 201.539C442.121 187.648 444.097 175.734 444.097 175.734L557.632 241.855Z",
    fill: "#F3F6FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M582.447 254.058L556.478 269.178C557.279 260.01 557.738 250.756 557.685 241.855L580.727 226.201C579.862 230.304 580.791 241.139 582.447 254.058Z",
    fill: "#D4DFFC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M530.925 204.606L518.458 211.818L506.024 204.638C506.024 204.638 493.6 53.7587 518.458 68.0345C543.37 82.4172 530.925 204.606 530.925 204.606Z",
    fill: "#F3F6FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M533.575 164.717C533.425 168.628 533.254 172.389 533.041 175.926C532.143 192.724 530.904 204.606 530.904 204.606L518.438 211.819V68.0347C533.97 76.9891 535.006 127.692 533.575 164.717Z",
    fill: "url(#paint45_linear_504_7204)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M513.758 100.764C512.82 101.362 511.612 101.324 510.713 100.668C508.697 99.486 507.473 97.3101 507.509 94.9727C507.701 93.0172 509.357 92.2586 511.237 93.2096C510.701 93.6444 510.372 94.2838 510.329 94.9727C510.3 97.3084 511.522 99.4811 513.534 100.668C513.605 100.707 513.68 100.739 513.758 100.764Z",
    fill: "url(#paint46_linear_504_7204)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M514.655 99.0117C514.627 99.699 514.299 100.339 513.758 100.764C513.684 100.739 513.612 100.706 513.544 100.668C511.533 99.481 510.31 97.3083 510.339 94.9726C510.382 94.2837 510.712 93.6443 511.247 93.2095L511.461 93.3163C513.473 94.5011 514.693 96.6765 514.655 99.0117Z",
    fill: "#012860"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M505.778 225.058C505.739 225.992 505.294 226.862 504.56 227.441C503.492 228.221 502.039 228.221 500.426 227.302C497.766 225.774 495.822 222.311 496.153 219.565C496.484 216.819 498.653 215.89 501.206 217.172L501.494 217.321C504.133 218.839 506.066 222.258 505.778 225.058Z",
    fill: "url(#paint47_linear_504_7204)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M196.709 62.6706C196.832 65.3693 198.123 67.8811 200.245 69.552C203.172 71.8173 207.552 71.8173 212.209 69.1673C219.933 64.7435 225.552 54.7099 224.697 46.7278C223.928 39.0343 217.433 36.0423 210.052 39.8036C209.785 39.9212 209.475 40.0814 209.208 40.231C201.473 44.6228 195.865 54.6671 196.709 62.6706Z",
    fill: "url(#paint48_linear_504_7204)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M209.528 63.5787L204.037 55.5645C203.811 55.211 203.9 54.7417 204.24 54.496C204.596 54.2799 205.057 54.3676 205.309 54.699L209.293 60.5226L217.145 44.6653C217.361 44.3245 217.8 44.2014 218.162 44.3798C218.524 44.5581 218.693 44.9806 218.555 45.3599L209.528 63.5787Z",
    fill: "#F3F6FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M556.467 269.178C553.048 308.928 543.434 347.118 543.071 348.56C506.077 260.651 439.45 202.415 438.467 201.507L556.467 269.178Z",
    fill: "url(#paint49_linear_504_7204)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M571.337 330.235C578.943 284.351 567.523 262.756 567.523 262.756L582.479 254.058C586.1 282.001 593.162 319.635 593.162 319.635C585.667 322.696 578.377 326.237 571.337 330.235Z",
    fill: "url(#paint50_linear_504_7204)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M385.813 244.698C385.813 244.698 382.779 244.879 371.488 250.746C360.378 256.537 348.948 265.887 348.595 266.186L311.366 244.698C311.772 244.388 325.072 234.472 334.238 229.257C343.852 223.797 348.584 223.209 348.584 223.209L385.813 244.698Z",
    fill: "url(#paint51_linear_504_7204)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M385.813 244.698L348.595 266.186C348.947 265.887 360.346 256.569 371.488 250.746C382.779 244.847 385.813 244.698 385.813 244.698Z",
    fill: "#012860"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M385.813 244.666V251.825L348.595 273.356L348.605 266.154L385.813 244.666Z",
    fill: "url(#paint52_linear_504_7204)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M348.595 273.356L311.366 251.793V244.666L348.606 266.154L348.595 273.356Z",
    fill: "url(#paint53_linear_504_7204)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M311.366 251.793L317.573 319.892L348.595 337.811V273.356L311.366 251.793Z",
    fill: "#D4DFFC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M385.813 251.825L379.606 319.902L348.595 337.811V273.356L385.813 251.825Z",
    fill: "#F3F6FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M336.598 304.601C336.073 304.596 335.59 304.316 335.326 303.863L321.695 279.8C321.5 279.465 321.448 279.065 321.55 278.691C321.653 278.317 321.902 278.001 322.24 277.812C322.577 277.619 322.977 277.568 323.352 277.67C323.727 277.773 324.045 278.02 324.238 278.357L337.869 302.421C338.064 302.756 338.116 303.155 338.014 303.529C337.911 303.903 337.663 304.22 337.324 304.408C337.103 304.534 336.852 304.6 336.598 304.601Z",
    fill: "url(#paint54_linear_504_7204)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M322.967 296.747C322.301 296.752 321.715 296.307 321.542 295.664C321.368 295.02 321.651 294.341 322.23 294.011L336.256 285.933C336.71 285.644 337.285 285.627 337.755 285.889C338.225 286.151 338.513 286.65 338.506 287.188C338.498 287.726 338.196 288.216 337.72 288.465L323.693 296.544C323.474 296.676 323.223 296.746 322.967 296.747Z",
    fill: "url(#paint55_linear_504_7204)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M360.004 304.6C359.749 304.599 359.5 304.533 359.278 304.408C358.582 304.007 358.338 303.12 358.733 302.421L372.374 278.357C372.793 277.701 373.653 277.488 374.33 277.872C375.007 278.256 375.265 279.103 374.917 279.799L361.275 303.863C361.013 304.318 360.529 304.598 360.004 304.6Z",
    fill: "url(#paint56_linear_504_7204)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M373.635 296.747C373.379 296.746 373.128 296.676 372.908 296.544L358.936 288.508C358.459 288.259 358.157 287.769 358.15 287.231C358.142 286.693 358.43 286.194 358.9 285.932C359.37 285.67 359.945 285.687 360.399 285.976L374.425 294.054C375.004 294.384 375.287 295.063 375.113 295.707C374.94 296.35 374.354 296.795 373.688 296.789L373.635 296.747Z",
    fill: "url(#paint57_linear_504_7204)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M247.655 179.516C247.199 177.845 246.478 176.257 245.518 174.815L250.507 165.946L241.299 161.03L236.353 169.824C234.568 169.773 232.786 170.008 231.075 170.519L231.011 162.409L218.096 170.305L218.16 178.416C216.274 180.195 214.525 182.113 212.926 184.154L207.883 181.472L198.846 197.5L203.92 200.214C203.045 202.595 202.349 205.038 201.837 207.523L194.69 211.904L194.808 226.746L202.051 222.322C202.528 223.952 203.267 225.493 204.241 226.885L199.156 235.936L208.364 240.862L213.492 231.736C215.216 231.762 216.935 231.525 218.587 231.031L218.651 239.472L231.556 231.576L231.492 223.134C232.56 222.183 233.5 221.157 234.462 220.1L225.478 215.27L224.944 215.601C217.882 219.875 212.124 216.841 212.028 208.698C211.932 200.556 217.637 190.469 224.709 186.141C231.78 181.814 237.528 184.912 237.634 193.033C237.637 193.651 237.609 194.268 237.549 194.882L246.49 199.049C246.987 197.512 247.4 195.95 247.73 194.369L254.972 189.945L254.855 175.103L247.655 179.516Z",
    fill: "#D4DFFC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M228.543 204.018C227.977 205.012 227.058 205.578 226.492 205.268C225.926 204.958 225.905 203.911 226.492 202.907C227.08 201.902 227.966 201.347 228.543 201.657C229.12 201.966 229.099 203.024 228.543 204.018Z",
    fill: "#F3F6FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M232.486 200.075C233.896 195.438 233.244 191.27 230.541 189.828C228.818 189.053 226.826 189.165 225.2 190.127L226.546 198.216L222.743 204.99L215.383 206.518C215.383 209.072 216.323 211.103 218.043 212.021C220.457 213.304 223.875 212.086 226.899 209.201C228.374 207.762 229.633 206.117 230.638 204.317C231.408 202.976 232.028 201.553 232.486 200.075ZM226.493 205.268C225.916 204.969 225.905 203.911 226.493 202.907C227.08 201.902 227.967 201.347 228.544 201.657C229.121 201.966 229.121 203.014 228.544 204.018C227.967 205.022 227.059 205.578 226.471 205.268H226.493Z",
    fill: "url(#paint58_linear_504_7204)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259.588 217.524L256.96 222.205C256.244 223.487 255.069 224.203 254.332 223.807L226.963 209.2C228.438 207.762 229.697 206.117 230.702 204.317C231.468 202.965 232.08 201.531 232.529 200.043L259.566 214.479C260.261 214.896 260.271 216.253 259.588 217.524Z",
    fill: "url(#paint59_linear_504_7204)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M248.691 216.231L234.098 208.442C233.746 208.26 233.735 207.598 234.098 206.978C234.451 206.358 235.017 206.005 235.38 206.198L249.973 213.988C250.325 214.18 250.336 214.832 249.973 215.451C249.62 216.082 249.054 216.424 248.691 216.231Z",
    fill: "#F3F6FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M102.756 217.685C102.756 217.207 102.369 216.819 101.891 216.819C101.413 216.819 101.025 217.207 101.025 217.685V222.889C101.025 223.367 101.413 223.754 101.891 223.754C102.369 223.754 102.756 223.367 102.756 222.889V217.685Z",
    fill: "#D4DFFC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M101.891 208.367C101.413 208.367 101.025 207.98 101.025 207.502V197.329C101.031 196.849 101.422 196.463 101.901 196.463C102.379 196.463 102.767 196.851 102.767 197.329V207.502C102.767 207.733 102.674 207.955 102.509 208.117C102.345 208.28 102.122 208.37 101.891 208.367ZM101.891 188.065C101.413 188.065 101.025 187.677 101.025 187.199V177.016C101.031 176.54 101.415 176.156 101.891 176.15C102.37 176.156 102.756 176.547 102.756 177.027V187.199C102.756 187.673 102.375 188.059 101.901 188.065H101.891ZM101.891 167.762C101.411 167.756 101.025 167.366 101.025 166.886V156.713C101.025 156.235 101.413 155.848 101.891 155.848C102.369 155.848 102.756 156.235 102.756 156.713V166.886C102.718 167.328 102.356 167.673 101.912 167.687L101.891 167.762ZM101.891 147.46C101.413 147.46 101.025 147.072 101.025 146.594V136.422C101.025 135.944 101.413 135.556 101.891 135.556C102.369 135.556 102.756 135.944 102.756 136.422V146.594C102.689 147.011 102.334 147.321 101.912 147.332L101.891 147.46Z",
    fill: "#D4DFFC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M101.923 126.986C101.445 126.986 101.058 126.599 101.058 126.121V120.415L105.993 117.562C106.262 117.407 106.593 117.408 106.862 117.564C107.13 117.719 107.295 118.007 107.294 118.317C107.293 118.627 107.127 118.914 106.858 119.068L102.799 121.419V126.121C102.799 126.352 102.706 126.574 102.542 126.737C102.377 126.899 102.154 126.989 101.923 126.986Z",
    fill: "#D4DFFC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M115.234 114.089C114.925 114.092 114.64 113.928 114.486 113.662C114.37 113.462 114.339 113.224 114.399 113.002C114.459 112.779 114.606 112.59 114.806 112.475L123.609 107.389C123.877 107.213 124.22 107.2 124.501 107.355C124.782 107.51 124.954 107.807 124.949 108.128C124.943 108.449 124.76 108.74 124.474 108.885L115.672 113.982C115.537 114.054 115.386 114.09 115.234 114.089ZM132.849 103.916C132.46 103.913 132.12 103.649 132.021 103.273C131.921 102.896 132.085 102.499 132.422 102.303L141.224 97.2059C141.493 97.0513 141.824 97.052 142.093 97.2078C142.361 97.3636 142.526 97.6507 142.525 97.9611C142.525 98.2715 142.359 98.5579 142.09 98.7126L133.287 103.799C133.153 103.874 133.003 103.914 132.849 103.916ZM150.465 93.7331C150.157 93.7359 149.871 93.5726 149.717 93.3057C149.601 93.1061 149.57 92.8686 149.63 92.6459C149.69 92.4232 149.837 92.2338 150.037 92.1196L158.84 87.0333C159.108 86.8573 159.452 86.8441 159.732 86.999C160.013 87.1539 160.186 87.4516 160.18 87.7724C160.174 88.0932 159.991 88.3845 159.705 88.5293L150.903 93.6156C150.771 93.695 150.619 93.7358 150.465 93.7331ZM168.08 83.5605C167.683 83.5656 167.334 83.2995 167.233 82.9154C167.132 82.5312 167.305 82.1275 167.653 81.9363L176.455 76.8501C176.655 76.7344 176.892 76.7032 177.115 76.7634C177.338 76.8236 177.527 76.9702 177.641 77.1706C177.756 77.3686 177.787 77.6045 177.727 77.8254C177.667 78.0464 177.52 78.234 177.321 78.346L168.518 83.443C168.384 83.5178 168.234 83.5581 168.08 83.5605Z",
    fill: "#D4DFFC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M185.695 73.3772C185.306 73.3736 184.967 73.1101 184.867 72.7334C184.767 72.3567 184.931 71.9598 185.268 71.7637L189.765 69.1565C190.034 69.0019 190.365 69.0026 190.634 69.1583C190.902 69.3141 191.067 69.6013 191.067 69.9117C191.066 70.2221 190.9 70.5085 190.631 70.6631L186.133 73.2597C186.001 73.3392 185.849 73.3799 185.695 73.3772Z",
    fill: "#D4DFFC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M234.355 45.3066C234.045 45.3049 233.76 45.1378 233.607 44.8685C233.491 44.6718 233.458 44.4369 233.517 44.2161C233.575 43.9953 233.719 43.807 233.917 43.6931L238.425 41.0858C238.841 40.8468 239.372 40.9903 239.611 41.4064C239.849 41.8224 239.706 42.3535 239.29 42.5925L234.793 45.189C234.659 45.2638 234.508 45.3042 234.355 45.3066Z",
    fill: "#D4DFFC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M247.677 37.613C247.285 37.6142 246.942 37.3522 246.839 36.9743C246.736 36.5963 246.9 36.1965 247.239 35.9995L256.052 30.9132C256.32 30.7372 256.663 30.724 256.944 30.8789C257.225 31.0338 257.397 31.3315 257.392 31.6523C257.386 31.9731 257.203 32.2644 256.917 32.4092L248.104 37.4955C247.975 37.5735 247.827 37.6142 247.677 37.613ZM265.303 27.4404C264.991 27.4382 264.702 27.2718 264.544 27.0023C264.31 26.5857 264.452 26.0579 264.865 25.8162L273.678 20.7299C274.094 20.4909 274.625 20.6345 274.864 21.0505C275.103 21.4666 274.959 21.9976 274.543 22.2366L265.73 27.3229C265.599 27.3964 265.453 27.4367 265.303 27.4404ZM282.929 17.2572C282.538 17.2583 282.194 16.9964 282.091 16.6184C281.989 16.2405 282.153 15.8407 282.491 15.6437L291.304 10.5467C291.573 10.3921 291.904 10.3928 292.173 10.5486C292.441 10.7043 292.606 10.9915 292.605 11.3019C292.605 11.6123 292.439 11.8987 292.17 12.0533L283.356 17.1396C283.228 17.2177 283.08 17.2584 282.929 17.2572ZM300.555 7.0739C300.164 7.07508 299.82 6.81313 299.718 6.43517C299.615 6.05721 299.779 5.65744 300.117 5.46038L308.931 0.374095C309.199 0.198051 309.542 0.184841 309.823 0.33977C310.104 0.494698 310.276 0.792343 310.27 1.11314C310.265 1.43394 310.082 1.72526 309.796 1.87006L300.983 6.96704C300.851 7.0372 300.704 7.0739 300.555 7.0739Z",
    fill: "#D4DFFC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M322.679 58.2894C322.199 58.2836 321.813 57.893 321.813 57.4132V47.6253C321.813 47.3161 321.978 47.0304 322.246 46.8757C322.514 46.7211 322.844 46.7211 323.111 46.8757C323.379 47.0304 323.544 47.3161 323.544 47.6253V57.4132C323.544 57.893 323.158 58.2836 322.679 58.2894ZM322.679 38.6922C322.201 38.6922 321.813 38.3047 321.813 37.8267V28.0281C321.813 27.5501 322.201 27.1626 322.679 27.1626C323.157 27.1626 323.544 27.5501 323.544 28.0281V37.8267C323.544 38.3047 323.157 38.6922 322.679 38.6922ZM322.679 19.0951C322.201 19.0951 321.813 18.7076 321.813 18.2295V8.43095C321.813 7.95294 322.201 7.56543 322.679 7.56543C323.157 7.56543 323.544 7.95294 323.544 8.43095V18.2295C323.544 18.7076 323.157 19.0951 322.679 19.0951Z",
    fill: "#D4DFFC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M322.679 73.2811C322.201 73.2811 321.813 72.8936 321.813 72.4155V67.2117C321.813 66.7337 322.201 66.3462 322.679 66.3462C323.157 66.3462 323.544 66.7337 323.544 67.2117V72.4155C323.544 72.8936 323.157 73.2811 322.679 73.2811Z",
    fill: "#D4DFFC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M385.813 244.698C343.35 230.208 312.018 244.388 311.377 244.698C311.783 244.388 325.083 234.472 334.248 229.257C343.863 223.797 348.595 223.209 348.595 223.209L385.813 244.698Z",
    fill: "url(#paint60_linear_504_7204)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M356.415 239.932V246.258L355.036 245.467V241.268C355.041 240.677 354.727 240.129 354.214 239.836L345.978 235.081C345.724 234.932 345.41 234.929 345.154 235.075C344.899 235.22 344.74 235.492 344.738 235.786V239.515L343.371 238.724V232.997C343.388 232.633 343.59 232.303 343.905 232.121C344.221 231.94 344.608 231.931 344.931 232.099L355.368 238.126C356.007 238.505 356.403 239.189 356.415 239.932Z",
    fill: "#012860"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M257.09 373.998C276.004 373.62 291.178 365.295 290.98 355.404C290.782 345.514 275.288 337.802 256.373 338.181C237.459 338.559 222.285 346.884 222.483 356.775C222.681 366.665 238.175 374.377 257.09 373.998Z",
    fill: "#F3F6FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M525.679 263.184C525.679 263.184 517.433 272.555 519.783 273.367C522.133 274.179 530.583 268.024 530.85 266.186C530.961 265.457 530.635 264.729 530.017 264.327L526.694 262.574L525.679 263.184Z",
    fill: "#012860"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M517.903 257.114C517.903 257.114 509.774 266.325 512.092 267.127C514.41 267.928 522.774 261.848 522.988 260.063C523.098 259.348 522.781 258.634 522.176 258.236L518.896 256.505L517.903 257.114Z",
    fill: "#012860"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M531.171 220.837C529.765 222.223 528.789 223.985 528.362 225.913C527.827 228.894 525.68 263.184 525.68 263.184C525.68 263.184 525.552 263.846 527.678 264.252C528.447 264.435 529.248 264.435 530.017 264.252C530.017 264.252 532.624 230.411 534.119 228.584C535.275 227.222 536.548 225.964 537.922 224.823C537.922 224.823 539.781 221.777 539.845 221.414C539.909 221.051 534.504 218.518 534.504 218.518L531.171 220.837Z",
    fill: "url(#paint61_linear_504_7204)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M523.308 215.419C521.921 216.779 520.96 218.513 520.542 220.41C520.007 223.348 517.903 257.114 517.903 257.114C517.903 257.114 517.775 257.755 519.858 258.183C520.616 258.378 521.409 258.396 522.176 258.236C522.176 258.236 524.729 224.908 526.203 223.113C527.343 221.774 528.598 220.537 529.953 219.416C529.953 219.416 531.78 216.402 531.844 216.05C531.908 215.697 526.502 213.208 526.502 213.208L523.308 215.419Z",
    fill: "url(#paint62_linear_504_7204)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M553.273 212.449C553.273 212.449 553.668 216.969 548.605 221.393C543.541 225.816 540.817 226.821 540.817 226.821C540.817 226.821 533.094 221.478 528.094 219.341C523.095 217.204 519.602 218.379 519.602 218.379C521.513 214.941 523.905 211.792 526.705 209.03C528.671 207.059 530.904 205.376 533.339 204.029C533.339 204.029 539.3 203.185 539.482 203.185C539.663 203.185 546.169 203.847 546.169 203.847L551.286 204.691L553.273 212.449Z",
    fill: "url(#paint63_linear_504_7204)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M564.202 179.452C564.202 179.452 558.55 182.433 557.033 184.196C555.517 185.96 555.709 187.819 554.619 189.667C553.001 192.696 552.647 196.242 553.636 199.53C554.908 203.708 553.273 212.449 553.273 212.449C553.273 212.449 546.949 207.982 543.584 207.106C540.219 206.23 540.443 206.753 536.897 205.845C533.35 204.937 533.34 203.975 533.34 203.975C533.34 203.975 534.483 196.378 535.262 192.467C536.042 188.556 533.724 186.537 535.957 183.267C536.769 182.07 534.461 181.13 532.752 180.606C532.912 177.988 533.115 175.146 533.222 172.261C535.786 173.265 539.995 174.612 541.02 174.505C542.655 174.344 546.81 176.439 546.81 176.439L549.855 176.022C551.557 176.57 553.387 176.57 555.089 176.022C557.813 175.082 561.958 173.084 561.958 173.084C561.949 173.804 562.035 174.523 562.215 175.221C562.335 175.705 562.481 176.183 562.653 176.652C562.922 177.432 563.28 178.178 563.721 178.875C563.945 179.174 564.084 179.345 564.127 179.388L564.202 179.452Z",
    fill: "url(#paint64_linear_504_7204)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M547.109 180.863C548.029 180.604 549.017 180.862 549.694 181.536C550.901 182.679 551.019 183.224 551.019 183.224L549.876 176.054L546.18 177.593L547.109 180.863Z",
    fill: "#B4CBFC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M545.88 180.585C545.35 180.433 544.793 180.393 544.246 180.467C543.718 180.571 543.227 180.814 542.825 181.172L545.442 176.535L546.511 177.144L547.088 178.64L545.88 180.585Z",
    fill: "#B4CBFC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M549.566 173.308L549.876 176.043C549.876 176.043 548.583 181.322 546.5 180.895C544.417 180.467 545.432 176.503 545.432 176.503C545.431 175.911 545.352 175.322 545.197 174.75C545.111 174.226 545.277 173.691 545.646 173.308C545.72 173.393 549.566 173.308 549.566 173.308Z",
    fill: "url(#paint65_linear_504_7204)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M541.608 165.443C541.017 167.212 540.932 169.111 541.362 170.925C542.024 174.302 543.499 175.509 543.499 175.509C543.499 175.509 549.075 176.107 550.656 171.171C551.526 168.034 551.004 164.675 549.225 161.949L544.588 162.248L541.608 165.443Z",
    fill: "url(#paint66_linear_504_7204)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M541.607 165.39C541.607 165.39 546.265 164.215 547.622 166.64C548.978 169.066 547.515 170.38 550.153 172.806C552.792 175.231 557.749 162.483 550.207 159.898C541.8 156.991 541.607 165.39 541.607 165.39Z",
    fill: "#012860"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M550.282 159.876C550.282 159.876 552.173 157.536 553.487 158.626C554.801 159.716 554.748 167.014 556.083 166.961C557.418 166.907 557.771 166.223 557.771 166.223C557.771 166.223 556.168 170.359 553.978 168.735C551.788 167.11 551.618 162.772 551.618 162.772L550.282 159.876Z",
    fill: "#012860"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M573.655 172.613C571.519 174.932 566.327 177.668 564.5 178.576L563.859 178.897H563.742C563.301 178.199 562.942 177.454 562.673 176.674C562.502 176.205 562.356 175.727 562.235 175.242C562.235 174.922 562.299 174.729 562.299 174.729C562.299 174.729 562.78 174.526 563.517 174.184C565.568 173.233 569.564 171.224 569.788 169.91C570.087 168.094 570.931 150.975 569.788 150.078C568.547 149.273 567.756 147.931 567.651 146.455C567.534 144.714 572.993 143.87 573.805 145.494C574.617 147.118 572.736 148.507 572.95 150.078C573.164 151.649 576.294 169.782 573.655 172.613Z",
    fill: "url(#paint67_linear_504_7204)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M563.517 174.173C562.78 174.515 562.3 174.718 562.3 174.718C562.3 174.718 562.3 174.911 562.236 175.231C562.056 174.533 561.97 173.815 561.979 173.094C561.979 173.094 562.706 173.105 563.517 174.173Z",
    fill: "#012860"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M564.543 178.576C564.475 178.884 564.359 179.179 564.201 179.452C564.201 179.452 564.019 179.238 563.795 178.939H563.912L564.543 178.576Z",
    fill: "#012860"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M502.979 165.123C502.979 165.123 502.488 171.534 504.464 171.32C506.44 171.107 507.423 169.835 507.241 167.805C507.06 165.775 505.415 163.05 504.165 163.103C502.915 163.157 502.979 165.123 502.979 165.123Z",
    fill: "url(#paint68_linear_504_7204)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M272.407 295.24C272.407 295.24 269.682 307.336 267.578 310.2C266.082 312.262 265.068 324.935 264.608 332.105L264.234 332.671V331.838C264.971 321.152 265.922 310.467 266.884 308.33C268.945 303.724 270.345 297.975 269.992 296.009C269.937 295.729 269.817 295.465 269.64 295.24H272.407Z",
    fill: "url(#paint69_linear_504_7204)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M262.846 355.955C263.444 357.076 263.717 358.342 263.636 359.609C263.433 361.511 262.846 362.516 258.648 361.618C254.449 360.721 247.815 360.422 247.741 358.84C247.666 357.259 257.718 355.805 257.718 355.805L262.846 355.955Z",
    fill: "url(#paint70_linear_504_7204)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M269.768 351.232C270.359 352.351 270.629 353.612 270.548 354.876C270.345 356.788 269.768 357.793 265.559 356.895C261.35 355.998 254.737 355.698 254.652 354.117C254.566 352.535 264.629 351.082 264.629 351.082L269.768 351.232Z",
    fill: "url(#paint71_linear_504_7204)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M273.795 303.596C272.727 305.904 271.755 317.851 270.996 329.241C270.238 340.632 269.768 351.275 269.768 351.275C269.047 352.056 267.958 352.384 266.926 352.13C264.918 351.841 264.629 351.125 264.629 351.125L264.49 344.393L264.33 337.116L264.245 332.757L264.619 332.19C265.078 325.021 266.093 312.348 267.588 310.285C269.725 307.389 272.417 295.326 272.417 295.326H269.629C269.806 295.55 269.926 295.814 269.981 296.095C270.334 298.061 268.913 303.81 266.873 308.415C265.911 310.552 264.96 321.238 264.223 331.923L263.476 296.661V295.464L263.711 295.293L265.089 294.225L266.104 293.466H266.189L272.599 288.626C272.599 288.626 276.53 289.406 276.872 291.372C277.213 293.338 275.857 299.001 273.795 303.596Z",
    fill: "url(#paint72_linear_504_7204)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M266.873 308.33C265.912 310.467 264.961 321.152 264.224 331.838L264.16 332.789C264.074 334.039 263.989 335.289 263.914 336.518C263.754 339.061 263.615 341.54 263.476 343.816C263.081 350.762 262.846 355.923 262.846 355.923C262.13 356.705 261.044 357.033 260.015 356.778C257.996 356.5 257.718 355.784 257.718 355.784L257.398 340.824L257.269 334.723L257.13 328.312L256.682 306.876L256.532 300.123L263.059 295.229L265.698 293.252C265.698 293.252 265.912 293.252 266.157 293.37C267.329 293.636 268.425 294.166 269.362 294.919L269.629 295.229C269.806 295.454 269.927 295.718 269.982 295.999C270.334 297.975 268.935 303.724 266.873 308.33Z",
    fill: "url(#paint73_linear_504_7204)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M236.31 249.314C235.482 249.05 234.767 248.516 234.28 247.797C232.56 245.339 235.22 245.435 232.752 243.148C231.876 242.336 232.945 241.31 234.718 240.744C236.491 240.178 238.991 244.42 238.638 247.764C238.286 251.109 236.31 249.314 236.31 249.314Z",
    fill: "url(#paint74_linear_504_7204)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M259.138 235.765C258.355 235.545 257.67 235.067 257.194 234.408C255.506 232.164 257.995 232.164 255.624 230.133C254.78 229.407 255.741 228.402 257.386 227.825C259.031 227.248 261.51 231.127 261.264 234.237C261.018 237.346 259.138 235.765 259.138 235.765Z",
    fill: "url(#paint75_linear_504_7204)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M273.816 260.662C273.816 260.662 264.725 233.061 259.683 234.514C255.175 235.818 266.371 261.228 266.371 261.228L273.816 260.662Z",
    fill: "url(#paint76_linear_504_7204)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M267.62 255.501L267.983 260.095C267.983 260.095 265.847 262.232 265.783 262.232C265.719 262.232 261.958 261.858 261.958 261.858C261.993 259.947 261.918 258.034 261.734 256.131L261.488 255.426L266.958 254.047L267.62 255.501Z",
    fill: "url(#paint77_linear_504_7204)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M259.235 246.301C259.235 246.301 256.746 251.793 257.408 252.135C258.07 252.477 257.12 256.783 259.812 256.697C262.905 256.706 265.745 254.987 267.172 252.242C268.913 249.036 264.469 244.548 264.469 244.548L261.179 243.672L259.235 246.301Z",
    fill: "url(#paint78_linear_504_7204)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.384 238.596C259.384 238.596 255.581 243.672 259.234 246.301C262.888 248.929 262.546 249.998 261.98 251.066C261.639 251.629 261.561 252.312 261.766 252.936C261.766 252.936 264.896 249.175 265.281 251.483C265.665 253.791 262.012 254.421 264.212 255.437C266.413 256.452 271.412 255.073 272.32 250.479C273.228 245.884 270.184 244.163 270.184 244.163C270.184 244.163 270.43 241.385 268.432 240.37C266.434 239.355 264.8 240.53 263.956 240.049C263.112 239.569 264.373 237.079 262.578 236.31C261.563 235.882 259.384 238.596 259.384 238.596Z",
    fill: "#012860"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M278.399 293.851C277.879 294.433 277.282 294.944 276.626 295.368C276.282 295.566 275.925 295.741 275.558 295.892C275.265 296.017 274.965 296.128 274.661 296.223L273.763 292.547L273.347 296.608C273.347 296.608 272.054 297.527 266.296 298.884C262.423 299.679 258.434 299.722 254.545 299.012C254.078 296.86 254.049 294.636 254.46 292.472C255.09 288.348 255.784 288.284 256.351 280.141C256.917 271.999 249.941 267.554 243.852 260.908C237.763 254.261 234.238 250.222 237.378 247.764C239.248 246.29 246.907 253.887 252.686 258.215H252.751C255.411 260.192 257.654 261.42 258.754 260.811L262.162 258.856C264.88 257.291 268.137 256.96 271.114 257.948L271.552 258.097C274.949 259.412 275.291 263.258 274.757 268.783C274.757 268.943 274.757 269.114 274.757 269.285C274.169 275.044 275.825 278.902 277.064 283.55C277.863 286.928 278.311 290.38 278.399 293.851Z",
    fill: "url(#paint79_linear_504_7204)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M258.732 260.94C257.664 261.869 256.596 265.128 255.089 266.208C253.583 267.287 255.089 264.573 255.388 262.617C255.677 260.875 253.252 258.749 252.729 258.343C255.388 260.32 257.632 261.581 258.732 260.94Z",
    fill: "url(#paint80_linear_504_7204)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M278.399 293.851C277.878 294.433 277.282 294.944 276.626 295.368C276.282 295.566 275.925 295.741 275.557 295.892C275.227 295.121 275.13 294.27 275.28 293.445C275.739 289.598 272.075 291.169 269.361 289.897C266.648 288.626 273.229 284.555 273.752 281.702C274.382 278.903 272.775 276.085 270.045 275.205C267.075 273.976 274.746 268.793 274.746 268.793C274.746 268.954 274.746 269.125 274.746 269.296C274.158 275.055 275.814 278.913 277.053 283.561C277.855 286.935 278.306 290.384 278.399 293.851Z",
    fill: "url(#paint81_linear_504_7204)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M318.523 435.508L310.127 430.646L305.929 433.083L314.336 437.934L318.523 435.508Z",
    fill: "url(#paint82_linear_504_7204)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M305.929 433.083V437.934L314.336 442.785V437.934L305.929 433.083Z",
    fill: "url(#paint83_linear_504_7204)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M301.88 445.211L293.483 440.349L289.285 442.785L297.692 447.636L301.88 445.211Z",
    fill: "url(#paint84_linear_504_7204)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M289.285 442.785V447.636L297.692 452.488V447.636L289.285 442.785Z",
    fill: "url(#paint85_linear_504_7204)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M284.606 454.913L276.209 450.051L272.011 452.488L280.418 457.339L284.606 454.913Z",
    fill: "url(#paint86_linear_504_7204)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M272.011 452.488V457.339L280.418 462.19V457.339L272.011 452.488Z",
    fill: "url(#paint87_linear_504_7204)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.642 435.508L331.631 440.359L335.829 442.785V437.934L331.642 435.508Z",
    stroke: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M331.642 435.508L340.038 430.646L344.236 433.083L335.829 437.934L331.642 435.508Z",
    fill: "url(#paint88_linear_504_7204)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M344.236 433.083V437.934L335.829 442.785V437.934L344.236 433.083Z",
    fill: "url(#paint89_linear_504_7204)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.285 445.211V450.062L352.473 452.488V447.636L348.285 445.211Z",
    stroke: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M348.285 445.211L356.692 440.349L360.891 442.785L352.473 447.636L348.285 445.211Z",
    fill: "url(#paint90_linear_504_7204)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M360.891 442.785V447.636L352.473 452.488V447.636L360.891 442.785Z",
    fill: "url(#paint91_linear_504_7204)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.559 454.913L365.548 459.764L369.746 462.19V457.339L365.559 454.913Z",
    stroke: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M365.559 454.913L373.955 450.051L378.153 452.488L369.746 457.339L365.559 454.913Z",
    fill: "url(#paint92_linear_504_7204)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M378.153 452.488V457.339L369.746 462.19V457.339L378.153 452.488Z",
    fill: "url(#paint93_linear_504_7204)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 453.62L324.986 483.155L375.889 454.026L325.242 424.492L274.34 453.62Z",
    fill: "#F3F6FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 453.62L274.372 473.367L325.114 502.677L324.986 483.155L274.34 453.62Z",
    fill: "#D4DFFC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M273.005 469.381L272.994 474.233L277.192 476.658V471.807L273.005 469.381Z",
    fill: "#D4DFFC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M273.005 469.381L281.401 464.52L285.6 466.956L277.192 471.807L273.005 469.381Z",
    fill: "url(#paint94_linear_504_7204)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M285.6 466.956V471.807L277.192 476.658V471.807L285.6 466.956Z",
    fill: "url(#paint95_linear_504_7204)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M289.648 479.084L289.638 483.935L293.836 486.361V481.509L289.648 479.084Z",
    fill: "#D4DFFC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M289.648 479.084L298.045 474.222L302.243 476.658L293.836 481.509L289.648 479.084Z",
    fill: "url(#paint96_linear_504_7204)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M302.243 476.658V481.509L293.836 486.361V481.509L302.243 476.658Z",
    fill: "url(#paint97_linear_504_7204)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M306.922 488.786L306.911 493.637L311.109 496.063V491.212L306.922 488.786Z",
    fill: "#D4DFFC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M306.922 488.786L315.318 483.924L319.517 486.361L311.109 491.212L306.922 488.786Z",
    fill: "url(#paint98_linear_504_7204)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M319.517 486.361V491.212L311.109 496.063V491.212L319.517 486.361Z",
    fill: "url(#paint99_linear_504_7204)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M325.115 502.677L375.889 473.356V454.026L324.986 483.155L325.115 502.677Z",
    fill: "#DEE7FC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M377.085 469.392L377.096 474.243L372.897 476.669V471.818L377.085 469.392Z",
    fill: "#D4DFFC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M377.085 469.392L368.688 464.53L364.49 466.956L372.897 471.818L377.085 469.392Z",
    fill: "url(#paint100_linear_504_7204)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M364.49 466.956V471.807L372.897 476.669V471.818L364.49 466.956Z",
    fill: "url(#paint101_linear_504_7204)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M360.442 479.094L360.452 483.946L356.254 486.371V481.52L360.442 479.094Z",
    fill: "#D4DFFC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M360.441 479.094L352.045 474.232L347.847 476.669L356.254 481.52L360.441 479.094Z",
    fill: "url(#paint102_linear_504_7204)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M347.847 476.669V481.509L356.254 486.371V481.52L347.847 476.669Z",
    fill: "url(#paint103_linear_504_7204)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M343.179 488.797V493.648L338.98 496.074V491.222L343.179 488.797Z",
    fill: "#D4DFFC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M343.179 488.797L334.771 483.935L330.573 486.371L338.98 491.223L343.179 488.797Z",
    fill: "url(#paint104_linear_504_7204)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M330.573 486.371V491.212L338.98 496.074V491.223L330.573 486.371Z",
    fill: "url(#paint105_linear_504_7204)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M348.947 469.445L297.959 440.103L301.591 437.987L352.611 467.351L348.947 469.445Z",
    fill: "url(#paint106_linear_504_7204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_7204",
    x1: 220.499,
    y1: 330.951,
    x2: 625.637,
    y2: 330.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_7204",
    x1: 0.8014,
    y1: 402.394,
    x2: 220.617,
    y2: 402.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_504_7204",
    x1: 192.928,
    y1: 472.502,
    x2: 329.59,
    y2: 472.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_504_7204",
    x1: 159.203,
    y1: 412.492,
    x2: 537.89,
    y2: 412.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_504_7204",
    x1: 130.841,
    y1: 436.577,
    x2: 206.377,
    y2: 436.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_504_7204",
    x1: 139.44,
    y1: 470.386,
    x2: 249.525,
    y2: 470.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_504_7204",
    x1: 105.982,
    y1: 407.512,
    x2: 164.544,
    y2: 407.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_504_7204",
    x1: 358.994,
    y1: 397.142,
    x2: 506.277,
    y2: 402.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_504_7204",
    x1: 359.626,
    y1: 379.575,
    x2: 506.909,
    y2: 384.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_504_7204",
    x1: 410.288,
    y1: 380.73,
    x2: 456.475,
    y2: 380.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_504_7204",
    x1: 391.517,
    y1: 355.602,
    x2: 394.249,
    y2: 355.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_504_7204",
    x1: 433.767,
    y1: 308.372,
    x2: 439.578,
    y2: 308.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_504_7204",
    x1: 457.023,
    y1: 332.319,
    x2: 472.63,
    y2: 332.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_504_7204",
    x1: 500.277,
    y1: 398.252,
    x2: 502.334,
    y2: 398.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_504_7204",
    x1: 446.736,
    y1: 360.026,
    x2: 463.187,
    y2: 360.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_504_7204",
    x1: 472.297,
    y1: 403.675,
    x2: 477.219,
    y2: 403.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_504_7204",
    x1: 448.633,
    y1: 419.993,
    x2: 476.88,
    y2: 421.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_504_7204",
    x1: 409.262,
    y1: 376.46,
    x2: 416.782,
    y2: 376.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_504_7204",
    x1: 427.989,
    y1: 415.405,
    x2: 441.243,
    y2: 415.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_504_7204",
    x1: 389.947,
    y1: 377.764,
    x2: 395.993,
    y2: 377.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_504_7204",
    x1: 391.195,
    y1: 406.718,
    x2: 396.933,
    y2: 406.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_504_7204",
    x1: 392.338,
    y1: 421.657,
    x2: 421.66,
    y2: 422.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_504_7204",
    x1: 340.764,
    y1: 366.94,
    x2: 356.82,
    y2: 366.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_504_7204",
    x1: 364.984,
    y1: 402.141,
    x2: 368.419,
    y2: 402.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_504_7204",
    x1: 326.332,
    y1: 341.508,
    x2: 343.467,
    y2: 341.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0029E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_504_7204",
    x1: 388.877,
    y1: 367.434,
    x2: 507.415,
    y2: 371.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_504_7204",
    x1: 42.8906,
    y1: 338.356,
    x2: 47.0996,
    y2: 338.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_504_7204",
    x1: 60.7402,
    y1: 265.65,
    x2: 29.5256,
    y2: 265.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_504_7204",
    x1: 614.431,
    y1: 310.905,
    x2: 616.824,
    y2: 310.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_504_7204",
    x1: 624.714,
    y1: 247.224,
    x2: 606.991,
    y2: 247.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_504_7204",
    x1: 394.145,
    y1: 196.057,
    x2: 398.364,
    y2: 196.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_504_7204",
    x1: 411.917,
    y1: 122.705,
    x2: 380.702,
    y2: 122.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_504_7204",
    x1: 254.973,
    y1: 472.608,
    x2: 257.088,
    y2: 472.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_504_7204",
    x1: 263.828,
    y1: 409.147,
    x2: 248.221,
    y2: 409.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_504_7204",
    x1: 114.539,
    y1: 111.995,
    x2: 323.288,
    y2: 111.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_504_7204",
    x1: 79.7461,
    y1: 273.1,
    x2: 149.343,
    y2: 273.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_504_7204",
    x1: 102.243,
    y1: 261.367,
    x2: 132.966,
    y2: 261.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_504_7204",
    x1: 94.9895,
    y1: 269.734,
    x2: 140.209,
    y2: 269.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_504_7204",
    x1: 94.9895,
    y1: 278.1,
    x2: 140.209,
    y2: 278.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_504_7204",
    x1: 94.9901,
    y1: 286.478,
    x2: 140.209,
    y2: 286.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_504_7204",
    x1: 102.243,
    y1: 294.845,
    x2: 132.967,
    y2: 294.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_504_7204",
    x1: 210.063,
    y1: 258.29,
    x2: 261.318,
    y2: 258.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_504_7204",
    x1: 406.44,
    y1: 275.066,
    x2: 556.467,
    y2: 275.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_504_7204",
    x1: 543.061,
    y1: 301.331,
    x2: 593.162,
    y2: 301.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_504_7204",
    x1: 444.14,
    y1: 201.678,
    x2: 580.717,
    y2: 201.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_504_7204",
    x1: 518.47,
    y1: 139.927,
    x2: 534.045,
    y2: 139.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_504_7204",
    x1: 507.519,
    y1: 96.9922,
    x2: 513.758,
    y2: 96.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_504_7204",
    x1: 496.089,
    y1: 222.311,
    x2: 505.81,
    y2: 222.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_504_7204",
    x1: 196.624,
    y1: 54.7099,
    x2: 224.783,
    y2: 54.7099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_504_7204",
    x1: 438.456,
    y1: 275.076,
    x2: 556.467,
    y2: 275.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_504_7204",
    x1: 567.523,
    y1: 292.152,
    x2: 593.162,
    y2: 292.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_504_7204",
    x1: 311.366,
    y1: 244.666,
    x2: 385.813,
    y2: 244.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_504_7204",
    x1: 348.595,
    y1: 259.005,
    x2: 385.813,
    y2: 259.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_504_7204",
    x1: 311.366,
    y1: 259.005,
    x2: 348.595,
    y2: 259.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_504_7204",
    x1: 321.503,
    y1: 291.116,
    x2: 338.061,
    y2: 291.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_504_7204",
    x1: 321.503,
    y1: 291.244,
    x2: 338.446,
    y2: 291.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_504_7204",
    x1: 358.54,
    y1: 291.115,
    x2: 375.098,
    y2: 291.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_504_7204",
    x1: 358.156,
    y1: 291.244,
    x2: 375.098,
    y2: 291.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_504_7204",
    x1: 215.404,
    y1: 200.919,
    x2: 233.212,
    y2: 200.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_504_7204",
    x1: 226.92,
    y1: 212,
    x2: 260.079,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_504_7204",
    x1: 311.377,
    y1: 233.916,
    x2: 385.813,
    y2: 233.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_504_7204",
    x1: 525.68,
    y1: 241.513,
    x2: 539.845,
    y2: 241.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_504_7204",
    x1: 517.903,
    y1: 235.765,
    x2: 531.844,
    y2: 235.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_504_7204",
    x1: 519.602,
    y1: 214.992,
    x2: 553.284,
    y2: 214.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_504_7204",
    x1: 532.773,
    y1: 192.371,
    x2: 564.202,
    y2: 192.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_504_7204",
    x1: 545.133,
    y1: 177.112,
    x2: 549.876,
    y2: 177.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_504_7204",
    x1: 541.17,
    y1: 168.734,
    x2: 551.19,
    y2: 168.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_504_7204",
    x1: 562.235,
    y1: 161.778,
    x2: 574.723,
    y2: 161.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_504_7204",
    x1: 502.926,
    y1: 167.217,
    x2: 507.263,
    y2: 167.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_504_7204",
    x1: 264.224,
    y1: 313.972,
    x2: 272.417,
    y2: 313.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_504_7204",
    x1: 247.73,
    y1: 358.883,
    x2: 263.658,
    y2: 358.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_504_7204",
    x1: 254.652,
    y1: 354.16,
    x2: 270.58,
    y2: 354.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_504_7204",
    x1: 263.454,
    y1: 320.34,
    x2: 276.957,
    y2: 320.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_504_7204",
    x1: 256.532,
    y1: 325.063,
    x2: 270.035,
    y2: 325.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_504_7204",
    x1: 232.443,
    y1: 245.243,
    x2: 238.671,
    y2: 245.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_504_7204",
    x1: 255.314,
    y1: 231.961,
    x2: 261.285,
    y2: 231.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_504_7204",
    x1: 258.615,
    y1: 247.818,
    x2: 273.816,
    y2: 247.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002FE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_504_7204",
    x1: 261.488,
    y1: 258.14,
    x2: 267.983,
    y2: 258.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_504_7204",
    x1: 257.301,
    y1: 250.179,
    x2: 267.567,
    y2: 250.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_504_7204",
    x1: 236.203,
    y1: 273.602,
    x2: 278.399,
    y2: 273.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_504_7204",
    x1: 252.729,
    y1: 262.403,
    x2: 258.732,
    y2: 262.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0011BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_504_7204",
    x1: 268.688,
    y1: 282.396,
    x2: 278.399,
    y2: 282.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0011BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_504_7204",
    x1: 305.929,
    y1: 434.29,
    x2: 318.523,
    y2: 434.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_504_7204",
    x1: 305.929,
    y1: 437.934,
    x2: 314.336,
    y2: 437.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_504_7204",
    x1: 289.285,
    y1: 443.993,
    x2: 301.88,
    y2: 443.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_504_7204",
    x1: 289.285,
    y1: 447.636,
    x2: 297.692,
    y2: 447.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_504_7204",
    x1: 272.011,
    y1: 453.695,
    x2: 284.606,
    y2: 453.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_504_7204",
    x1: 272.011,
    y1: 457.339,
    x2: 280.418,
    y2: 457.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_504_7204",
    x1: 331.642,
    y1: 434.29,
    x2: 344.236,
    y2: 434.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_504_7204",
    x1: 335.829,
    y1: 437.934,
    x2: 344.236,
    y2: 437.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_504_7204",
    x1: 348.285,
    y1: 443.993,
    x2: 360.891,
    y2: 443.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_504_7204",
    x1: 352.483,
    y1: 447.636,
    x2: 360.891,
    y2: 447.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_504_7204",
    x1: 365.559,
    y1: 453.695,
    x2: 378.153,
    y2: 453.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_504_7204",
    x1: 369.746,
    y1: 457.339,
    x2: 378.153,
    y2: 457.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_504_7204",
    x1: 273.005,
    y1: 468.163,
    x2: 285.6,
    y2: 468.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_504_7204",
    x1: 277.192,
    y1: 471.807,
    x2: 285.6,
    y2: 471.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_504_7204",
    x1: 289.648,
    y1: 477.866,
    x2: 302.243,
    y2: 477.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_504_7204",
    x1: 293.836,
    y1: 481.509,
    x2: 302.243,
    y2: 481.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_504_7204",
    x1: 306.922,
    y1: 487.568,
    x2: 319.517,
    y2: 487.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_504_7204",
    x1: 311.109,
    y1: 491.212,
    x2: 319.517,
    y2: 491.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_504_7204",
    x1: 364.49,
    y1: 468.174,
    x2: 377.085,
    y2: 468.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_504_7204",
    x1: 364.49,
    y1: 471.807,
    x2: 372.897,
    y2: 471.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_504_7204",
    x1: 347.847,
    y1: 477.876,
    x2: 360.441,
    y2: 477.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_504_7204",
    x1: 347.847,
    y1: 481.52,
    x2: 356.254,
    y2: 481.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_504_7204",
    x1: 330.573,
    y1: 487.579,
    x2: 343.179,
    y2: 487.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_504_7204",
    x1: 330.573,
    y1: 491.223,
    x2: 338.98,
    y2: 491.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_504_7204",
    x1: 297.959,
    y1: 453.716,
    x2: 352.6,
    y2: 453.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls19);
export default __webpack_public_path__ + "static/media/ils_19.87390cb7f2d539d26fc348891c879752.svg";
export { ForwardRef as ReactComponent };